import { render, staticRenderFns } from "./Look.vue?vue&type=template&id=663e8cdd&scoped=true"
import script from "./Look.vue?vue&type=script&lang=js"
export * from "./Look.vue?vue&type=script&lang=js"
import style0 from "./Look.vue?vue&type=style&index=0&id=663e8cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e8cdd",
  null
  
)

export default component.exports